import { Directive, ElementRef, HostListener, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
    selector: '[fiDeviceSwitchHandler]',
    standalone: false,
})
export class DeviceSwitchHandlerDirective implements OnChanges {
    @Input('fiDeviceSwitchHandler') device;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnChanges(changes) {
        if (changes.device) {
            this.updateElementStyle();
        }
    }

    @HostListener('document:resize')
    updateElementStyle() {
        const el = this.elementRef.nativeElement,
            r = this.renderer;
        r.setStyle(el, 'max-width', this.device + 'px');

        if (this.device <= 768) {
            r.addClass(el, 'fi-device-size-break-mobile');
        } else {
            r.removeClass(el, 'fi-device-size-break-mobile');
        }

        if (this.device <= 450) {
            r.addClass(el, 'fi-device-size-break-mobile-small');
        } else {
            r.removeClass(el, 'fi-device-size-break-mobile-small');
        }
    }
}
